import { type CarriersFilterValues } from 'context/CarriersViewContext'
import { CARRIER_PREFIX, getRequest, postRequest } from 'global/helpers/requests'
import { sleep } from 'global/helpers/sleep'
import { type PaginatedResults } from 'global/types/pagination'
import type { CarrierData, EditCarrierFormValues } from './CarrierManager.types'

export const CARRIERS_QUERY_KEY = 'carriers'

export const getFilteredCarriers = async (
  page: number,
  filters: CarriersFilterValues,
): Promise<PaginatedResults<CarrierData>> => {
  const search = new URLSearchParams(
    Object.entries(filters).flatMap(([key, values]) => (values as string[]).map(value => [key, value]))
  )
  search.append('page', page.toString())
  return await getRequest<PaginatedResults<CarrierData>>(`carriers?${search.toString()}`, {}, CARRIER_PREFIX)
}

export const editCarrier = async (id: string, data: EditCarrierFormValues): Promise<void> => {
  const response = await postRequest<void>(`carriers/${id}`, { body: data }, CARRIER_PREFIX)
  await sleep(1000) // needed until backend is reworked to do synchronous updates
  return response
}
